import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class Showcase {
    constructor(query) {
        const el = document.querySelector(query);

        if (!el) return;

        this.el = el;
        this.inner = this.el.querySelector('.showcase__inner');
        this.texts = [...this.el.querySelectorAll('.showcase__text')];
        this.images = [...this.el.querySelectorAll('.showcase__image')];
        this.labels = [...this.el.querySelectorAll('.showcase__text-label')];

        this.itemsCount = Math.min(this.texts.length, this.images.length);
        this.currentIndex = 0;
        this.mm = gsap.matchMedia();
        this.stepMultiplier = 2;

        if (!this.inner || !this.texts.length || !this.images.length || this.itemsCount < 2) return;

        this.init();
    }

    init() {
        this.mm.add("(min-width: 1025px)", () => {
            this.setup();
            this.createTimeline();
        });

        this.mm.add("(max-width: 1025px)", () => {
            this.reset();
        });
    }

    setup() {
        const stepHeight = window.innerHeight * this.stepMultiplier;
        const totalHeight = window.innerHeight + (this.itemsCount - 1) * stepHeight;

        this.el.style.height = `${totalHeight}px`;

        this.texts.forEach((text, index) => {
            gsap.set(text, {
                opacity: index === 0 ? 1 : 0,
                y: index === 0 ? 0 : 20,
            });
        });

        this.images.forEach((image, index) => {
            gsap.set(image, {
                position: index === 0 ? 'relative' : 'absolute',
                inset: 0,
                zIndex: index + 1,
                yPercent: index === 0 ? 0 : 100,
            });
        });

        gsap.set(this.inner, {
            position: 'relative',
        });
    }


    createTimeline() {
        const stepHeight = window.innerHeight * this.stepMultiplier;

        this.tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.el,
                start: "top top",
                end: () => `+=${(this.itemsCount - 1) * stepHeight}`,
                scrub: true,
                pin: this.inner,
                pinSpacing: true,
                anticipatePin: 1,
                invalidateOnRefresh: true,
                onUpdate: (self) => {
                    const index = Math.min(
                        this.itemsCount - 1,
                        Math.round(self.progress * (this.itemsCount - 1))
                    );

                    this.setActiveText(index);
                },
            },
        });

        this.images.forEach((image, index) => {
            if (index === 0) return;

            this.tl.to(image, {
                yPercent: 0,
                duration: 1,
                ease: "none",
            });
        });
    }

    setActiveText(index) {
        if (this.currentIndex === index) return;

        const prev = this.texts[this.currentIndex];
        const next = this.texts[index];

        this.currentIndex = index;

        this.labels.forEach((label, labelIndex) => {
            label.classList.toggle('active', labelIndex === index);
        });

        gsap.to(prev, {
            y: -20,
            opacity: 0,
            duration: 0.3,
            ease: "power2.out",
        });

        gsap.fromTo(next,
            {
                y: 20,
                opacity: 0,
            },
            {
                y: 0,
                opacity: 1,
                duration: 0.3,
                ease: "power2.out",
            }
        );
    }

    reset() {
        this.el.style.height = '';
        this.currentIndex = 0;

        this.texts.forEach((text, index) => {
            text.classList.toggle('is-active', index === 0);
        });

        this.images.forEach((image) => {
            gsap.set(image, {
                clearProps: 'all',
            });
        });

        ScrollTrigger.getAll().forEach((trigger) => {
            if (trigger.trigger === this.el) {
                trigger.kill();
            }
        });
    }
}